/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-data-chart-venn-diagram': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M12.5 3.75a6.2 6.2 0 00-2.5.525 6.2 6.2 0 00-2.5-.525 6.25 6.25 0 000 12.5 6.2 6.2 0 002.5-.525 6.2 6.2 0 002.5.525 6.25 6.25 0 100-12.5zM7.5 15a5 5 0 111.1-9.875 6.25 6.25 0 000 9.75c-.36.083-.73.125-1.1.125zm5-5a5 5 0 01-2.5 4.325 5 5 0 010-8.65A5 5 0 0112.5 10zm0 5c-.37 0-.74-.042-1.1-.125a6.25 6.25 0 000-9.75A5 5 0 1112.5 15z"/>'
  }
})
